import isNil from 'lodash/isNil';

/**
 * Converts a comma-separated number string back to a number for sorting
 */
export default function buildSortNumber(stringNumber) {
  if (isNil(stringNumber)) {
    return 0;
  }

  if (typeof stringNumber === 'number') {
    return stringNumber;
  }

  if (typeof stringNumber !== 'string') {
    return 0;
  }

  return Number(stringNumber.trim().replace(/,/g, ''));
}
